import React from "react";
import {
    Waves,
    Wifi,
    UtensilsCrossed,
    WashingMachine,
    Armchair,
    Snowflake,
    Coffee,
    ShowerHead,
    Car,
    Sparkles,
    Tv,
} from "lucide-react";
import { useLanguage } from "../lib/i18n";

const AMENITIES = [
    { icon: Waves, title: "Private Pool", text: "Year-round outdoor pool with an adjoining dining and entertainment area." },
    { icon: Wifi, title: "Free High-Speed WiFi", text: "Throughout the villa — remote-work friendly." },
    { icon: Snowflake, title: "Air Conditioning", text: "All bedrooms and living areas." },
    { icon: UtensilsCrossed, title: "Full Kitchen", text: "Fully equipped with cookware, water cooler, dishwasher, induction stove top and fridge." },
    { icon: Coffee, title: "Dining Area", text: "Indoor + patio dining for breakfasts in the sun." },
    { icon: WashingMachine, title: "Washing Machine", text: "In-villa laundry for longer stays." },
    { icon: Armchair, title: "Patio Lounge", text: "Outdoor lounge for naps and novels. Bluetooth speaker available." },
    { icon: ShowerHead, title: "3 Bathrooms · Open to the Sky", text: "Fresh bathrooms with rain showers and skylights that open to sky and palms. Master bedroom with freestanding bathtub." },
    { icon: Tv, title: "Smart TVs", text: "Two large smart TVs — one in the master bedroom, another in the main lounge — for rainy-day movie nights." },
    { icon: Coffee, title: "Coffee Machine", text: "Wake up to proper coffee — machine set up for slow mornings." },
    { icon: Car, title: "Scooter & Itinerary Assistance", text: "We'll help you arrange island transport and tours." },
    { icon: Sparkles, title: "Housekeeping", text: "Daily tidy and linen change available on request." },
];

const Amenities = () => {
    const { t } = useLanguage();
    return (
        <div data-testid="amenities-page" className="pt-32 pb-24 bg-background">
            <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
                <div className="overline text-secondary mb-4">{t("page.amenities.overline")}</div>
                <h1 className="font-display text-5xl sm:text-6xl lg:text-7xl font-light text-primary leading-[0.95] tracking-tight max-w-3xl">
                    {t("page.amenities.title")}
                </h1>
                <p className="mt-6 max-w-xl text-muted-foreground font-light leading-relaxed">
                    {t("page.amenities.intro")}
                </p>

                <div className="mt-20 grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-px bg-border">
                    {AMENITIES.map((a, i) => (
                        <div
                            key={i}
                            data-testid={`amenity-${i}`}
                            className="bg-background p-8 lg:p-10 hover:bg-muted transition-colors duration-500"
                        >
                            <a.icon
                                size={26}
                                strokeWidth={1.25}
                                className="text-secondary"
                            />
                            <div className="mt-6 font-display text-2xl text-primary leading-tight">
                                {a.title}
                            </div>
                            <p className="mt-2 text-sm text-muted-foreground leading-relaxed font-light">
                                {a.text}
                            </p>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default Amenities;
